import React, { useEffect, useState } from "react";
import prevArrow from "../Assets/Images/Dashboard/prev_icon.png";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import upArrow from "../Assets/Images/Dashboard/up_arrow.png";
import downArrow from "../Assets/Images/Dashboard/down_arrow.png";
import "../Assets/Css/SchoolList.css";
import Sidebar from "../Component/Sidebar";
import Loader from "../Component/Loader";
import { Link } from "react-router-dom";
import { SCHOOL_LIST_GET_API } from "../Component/AllApi";
import profile_pic from "../Assets/Images/Dashboard/default_profile.svg";
import ExportToExcel from "../Component/ExportToExcel";

const Schools = () => {
  const [Data, SetData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const userRole = localStorage.getItem("user_role");

  useEffect(() => {
    setLoading(true);
    // console.log('data is fetching...');
    const fetchData = async () => {
      var token = localStorage.getItem("authToken");
      try {
        const response = await fetch(SCHOOL_LIST_GET_API, {
          method: "GET",
          headers: {
            Authorization: `bearer ${token}`,
          },
        });

        if (response.ok) {
          const data = await response.json();
          // console.log("data: ", data);
          SetData(data.allSchools);
          // console.log('data is fetched...');
        }
      } catch (err) {
        console.error("error", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(Number(pageNumber));
  };

  const nextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageCount));
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortDirection("asc");
    }
  };

  const sortData = (a, b) => {
    const keyA =
      typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
    const keyB =
      typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

    if (!isNaN(keyA) && !isNaN(keyB)) {
      return sortDirection === "asc" ? keyA - keyB : keyB - keyA;
    }

    if (sortDirection === "asc") {
      return keyA.localeCompare(keyB);
    } else {
      return keyB.localeCompare(keyA);
    }
  };

  const filteredData = Data.filter((data) =>
    Object.values(data).some(
      (value) =>
        value != null &&
        value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // For Diet Login temporarily
  // if (userRole === "Diet") {
  //   filteredData = filteredData.slice(0, 25);
  // }

  const displayedData =
    userRole === "Diet" ? filteredData.slice(0, 25) : filteredData;

  const sortedData = sortBy
    ? displayedData
        .slice(indexOfFirstItem, indexOfLastItem)
        .sort((a, b) => sortData(a, b))
    : displayedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(displayedData.length / itemsPerPage);
  const totalItems = displayedData.length;
  const pageCount = Math.ceil(totalItems / itemsPerPage);
  const PagePerItem = Math.min(totalItems - indexOfFirstItem, indexOfLastItem);
  const rangeStart = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);

  // Calculate indexes for pagination
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Get the data for the current page
  // const currentPageData = sortedData.slice(startIndex, endIndex);
  // const indexOfFirstItem = startIndex + 1; // Define indexOfFirstItem
  // const indexOfLastItem = endIndex; // Define indexOfLastItem

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <section className="schoolListSection sidebody">
            <div className="container">
              <div>
                <div className="schListHeader_div">
                  <p className="schListHeader_text">School List</p>
                  <div className="d-flex">
                    <div>
                      <ExportToExcel
                        data={Data}
                        fileName="Schools_list"
                        sheetName="Schools"
                        columns={[
                          { key: "school_code", alias: "School Code" },
                          { key: "school_name", alias: "School Name" },
                          { key: "school_loc", alias: "Address" },
                          { key: "princi_name", alias: "Principal Name" },
                          { key: "princi_mobile", alias: "Principal Mobile" },
                          { key: "princi_email", alias: "Principal Email" },
                        ]}
                      />
                    </div>
                    <div className="card searchBarCard">
                      <div
                        className="card-body d-flex"
                        style={{ padding: "0rem 1rem" }}
                      >
                        <input
                          className="form-control searchBar_input"
                          type="search"
                          placeholder="Search"
                          aria-label="Search"
                          value={searchQuery}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {sortedData?.length < 0 || sortedData?.length == 0 ? (
                <>
                  <p className="progressMainTitle text-center ">
                    No data available
                  </p>
                </>
              ) : (
                <div className="card schoolListTableDiv">
                  <div
                    className="card-body table-responsive"
                    style={{
                      maxHeight: "700px",
                      height: "698px",
                      overflow: "hidden",
                    }}
                  >
                    <table className="table table-borderless">
                      <thead
                        style={{ marginBottom: "20px" }}
                        className="thead_div"
                      >
                        <tr style={{ width: "5%" }} className="align-middle">
                          <th scope="col" className="thead_div_row">
                            Sr.No.
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "22%",
                              maxWidth: "22%",
                              minWidth: "22%",
                            }}
                            className="thead_div_row"
                          >
                            <span style={{ margin: "5px", display: "flex" }}>
                              <span style={{ marginTop: "3px" }}>
                                School Name
                              </span>
                              <span>
                                <button
                                  className="sort_button"
                                  type="button"
                                  onClick={() => handleSort("school_name")}
                                >
                                  <img
                                    className="desc"
                                    src={
                                      sortDirection === "asc" &&
                                      sortBy === "school_name"
                                        ? downArrow
                                        : upArrow
                                    }
                                    alt="Sort Button"
                                  />
                                </button>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            style={{
                              width: "18%",
                              maxWidth: "18%",
                              minWidth: "18%",
                            }}
                            className="thead_div_row"
                          >
                            <span style={{ margin: "5px", display: "flex" }}>
                              <span style={{ marginTop: "3px" }}>Location</span>

                              <span>
                                <button
                                  className="sort_button"
                                  type="button"
                                  onClick={() => handleSort("school_loc")}
                                >
                                  <img
                                    className="desc"
                                    src={
                                      sortDirection === "asc" &&
                                      sortBy === "school_loc"
                                        ? downArrow
                                        : upArrow
                                    }
                                    alt="Sort Button"
                                  />
                                </button>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            // style={{
                            //   width: "14%",
                            //   maxWidth: "14%",
                            //   minWidth: "14%",
                            // }}
                            className="thead_div_row"
                          >
                            <span style={{ margin: "5px", display: "flex" }}>
                              <span style={{ marginTop: "3px" }}>
                                {/* {`${
                                  userRole === "Diet" ? "Principal" : "Teacher"
                                }`} */}
                                Principal
                              </span>

                              <span>
                                <button
                                  className="sort_button"
                                  type="button"
                                  // onClick={() => handleSort("trainer_name")}
                                  onClick={() => handleSort("princi_name")}
                                >
                                  <img
                                    className="desc"
                                    src={
                                      sortDirection === "asc" &&
                                      sortBy === "princi_name"
                                        ? // sortBy === "trainer_name"
                                          downArrow
                                        : upArrow
                                    }
                                    alt="Sort Button"
                                  />
                                </button>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            style={{
                              textAlign:
                                userRole === "Diet" ? "left" : "center",
                            }}
                            className=""
                          >
                            {/* {`${
                              userRole === "Diet"
                                ? "Principal Mobile"
                                : "Teacher Mobile"
                            }`} */}
                            Principal Mobile
                          </th>
                          {userRole !== "Diet" && (
                            <th
                              scope="col"
                              style={{
                                textAlign:
                                  userRole === "Diet" ? "left" : "center",
                              }}
                              className="thead_div_row"
                            >
                              <span style={{ margin: "5px", display: "flex" }}>
                                <span style={{ marginTop: "3px" }}>
                                  Vid. Wat.
                                </span>

                                <span>
                                  <button
                                    className="sort_button"
                                    type="button"
                                    onClick={() => handleSort("vid_watched")}
                                  >
                                    <img
                                      className="desc"
                                      src={
                                        sortDirection === "asc" &&
                                        sortBy === "vid_watched"
                                          ? downArrow
                                          : upArrow
                                      }
                                      alt="Sort Button"
                                    />
                                  </button>
                                </span>
                              </span>
                            </th>
                          )}
                          {userRole !== "Diet" && (
                            <th
                              scope="col"
                              style={{ textAlign: "left" }}
                              className="thead_div_row"
                            >
                              <span style={{ margin: "5px", display: "flex" }}>
                                <span style={{ marginTop: "3px" }}>
                                  Vid. Rem.
                                </span>

                                <span>
                                  <button
                                    className="sort_button"
                                    type="button"
                                    onClick={() => handleSort("vid_remaining")}
                                  >
                                    <img
                                      className="desc"
                                      src={
                                        sortDirection === "asc" &&
                                        sortBy === "vid_remaining"
                                          ? downArrow
                                          : upArrow
                                      }
                                      alt="Sort Button"
                                    />
                                  </button>
                                </span>
                              </span>
                            </th>
                          )}
                          {userRole !== "Diet" && (
                            <th scope="col" className="thead_div_row">
                              <span style={{ margin: "5px", display: "flex" }}>
                                <span style={{ marginTop: "3px" }}>
                                  Progress
                                </span>

                                <span>
                                  <button
                                    className="sort_button"
                                    type="button"
                                    onClick={() => handleSort("vid_percentage")}
                                  >
                                    <img
                                      className="desc"
                                      src={
                                        sortDirection === "asc" &&
                                        sortBy === "vid_percentage"
                                          ? downArrow
                                          : upArrow
                                      }
                                      alt="Sort Button"
                                    />
                                  </button>
                                </span>
                              </span>
                            </th>
                          )}
                        </tr>
                      </thead>

                      <tbody>
                        {sortedData.map((data, index) => (
                          <tr key={index}>
                            <td style={{ paddingBottom: "28px" }}>
                              <span
                                className="header_srNo"
                                style={{ float: "left" }}
                              >
                                {index + indexOfFirstItem + 1}
                              </span>
                            </td>
                            <td>
                              <div
                                style={{ textAlign: "left" }}
                                className="d-flex"
                              >
                                <img
                                  src={require("../Assets/Images/Dashboard/schoolDummyLogo.png")}
                                  alt="loading"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                  }}
                                  className="tableRowInsideImg"
                                />

                                <span className="schoolname_text">
                                  {data.school_name}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span
                                style={{ float: "left" }}
                                className="location_text"
                              >
                                {`${data.school_loc}`}
                              </span>
                            </td>
                            <td className="text-left">
                              {/* <div className="d-flex">
                                <img
                                  src={
                                    data.trainer_image === null ||
                                    data.trainer_image === "" ||
                                    data.trainer_image === "NA"
                                      ? profile_pic
                                      : data.trainer_image
                                  }
                                  alt="loading"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                  }}
                                  onError={(e) => {
                                    e.target.src = profile_pic;
                                  }}
                                  className="tableRowInsideImg"
                                />

                                <Link
                                  to="/teacherParticularData"
                                  style={{ textDecoration: "none" }}
                                  onClick={() => {
                                    localStorage.setItem(
                                      "trainer_id",
                                      data.trainer_id
                                    );
                                    localStorage.setItem(
                                      "trainer_name",
                                      data.trainer_name
                                    );
                                  }}
                                  state={{ trainerId: data.trainer_id }}
                                  className="ms-2"
                                >
                                  {data.trainer_name === "Unallocated" ? (
                                    <span className="school_teacher_name">
                                      {data.trainer_name}
                                    </span>
                                  ) : (
                                    <span className="allocatedTeacher">
                                      {data.trainer_name}
                                    </span>
                                  )}
                                </Link>
                                
                              </div> */}
                              {data.princi_name === "Unallocated" ||
                              data.princi_name === null ? (
                                "-"
                              ) : (
                                <Link
                                  to="/school-dashboard"
                                  style={{ textDecoration: "none" }}
                                  state={{
                                    school_id: data.school_id,
                                    referrer: "/schools",
                                    principalName: data.princi_name,
                                  }}
                                >
                                  <span className="allocatedTeacher">
                                    {data.princi_name}
                                  </span>
                                </Link>
                                // <span className="allocatedTeacher">
                                //   {data.princi_name}
                                // </span>
                              )}
                            </td>
                            <td className="text-center">
                              <span
                                // style={{ float: "left" }}
                                className="teacher_mobile"
                              >
                                {data.princi_mobile === "NA" ||
                                data.princi_mobile === null
                                  ? "-"
                                  : data.princi_mobile}
                                {/* {data.trainer_phone === "NA"
                                  ? "-"
                                  : data.trainer_phone} */}
                              </span>
                            </td>
                            {userRole !== "Diet" && (
                              <td className="text-center">
                                <span className="teacher_mobile">
                                  {data?.vid_watched ? data.vid_watched : 0}
                                </span>
                              </td>
                            )}
                            {userRole !== "Diet" && (
                              <td className="text-center">
                                <span className="teacher_mobile">
                                  {data?.vid_remaining}
                                </span>
                              </td>
                            )}

                            {userRole !== "Diet" && (
                              <td className="text-center">
                                <span className="teacher_mobile">
                                  {data?.vid_percentage
                                    ? data.vid_percentage
                                    : 0}
                                  %
                                </span>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="pagination row">
                    <div className="result_msg col-12 col-lg-7 col-sm-7 col-md-7">
                      <p
                        className="result_msg_text"
                        style={{ marginBottom: "0px" }}
                      >
                        {/* {`Displaying ${
                      sortedData.length > 10
                        ? itemsPerPage
                        : sortedData.length
                    } results of ${totalItems} `} */}
                        Displaying {rangeEnd} results of {totalItems}
                      </p>
                    </div>

                    <div className="button_module col-12 col-lg-5 col-sm-5 col-md-5 d-flex ">
                      <div
                        className="d-flex"
                        style={{
                          alignItems: "center",
                          marginRight: "10px",
                        }}
                      >
                        <p className="paginate_msg_text">Page</p>
                        <div>
                          <select
                            className="form-select pageDropdown"
                            value={currentPage}
                            onChange={(e) => handlePageChange(e.target.value)}
                          >
                            {Array.from(
                              { length: pageCount },
                              (_, i) => i + 1
                            ).map((pageNum) => (
                              <option value={pageNum} key={pageNum}>
                                {pageNum}&nbsp;
                              </option>
                            ))}
                          </select>
                        </div>
                        <p className="paginate_msg_text">of {pageCount}</p>
                      </div>

                      <div className=" d-flex">
                        <button
                          type="button"
                          className="bton"
                          onClick={prevPage}
                          disabled={currentPage === 1}
                        >
                          <img
                            src={prevArrow}
                            alt="prev"
                            className="arrow_btn"
                          />
                        </button>

                        <button
                          type="button"
                          className="bton"
                          onClick={nextPage}
                          // disabled={indexOfLastItem >= filteredData.length}
                          disabled={currentPage === pageCount}
                        >
                          <img
                            src={nextArrow}
                            alt="next"
                            className="arrow_btn"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default Schools;
